
import { Button } from "@/components/ui/button";

interface DesktopNavProps {
  scrollToContact: () => void;
  isScrolled?: boolean;
}

export const DesktopNav = ({ scrollToContact, isScrolled = false }: DesktopNavProps) => {
  const linkClass = isScrolled 
    ? "text-foreground hover:text-[#ffa05d] transition-colors px-3 py-2" 
    : "text-white/90 hover:text-white transition-colors px-3 py-2";

  return (
    <nav className="hidden md:flex items-center space-x-6">
      <a href="#tech" className={linkClass}>
        Technology
      </a>
      <a href="#research" className={linkClass}>
        Research
      </a>
      <a href="#team" className={linkClass}>
        Team
      </a>
      <a href="#careers" className={linkClass}>
        Careers
      </a>
      <Button 
        onClick={scrollToContact}
        className="bg-[#ffa05d] hover:bg-[#ffa05d]/90 text-white"
      >
        Contact
      </Button>
    </nav>
  );
};
